import React from 'react';
import { AppDialog } from '../../Dialog/AppDialog';
import IframeComponent from './components/IframeComponent';

class SurveyDialog extends AppDialog {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      complete: false,
      name: '',
      questionnaireUrl: '',
    };
  }

  getDialogContentProps = () => ({
    ...this.props.DialogContentProps,
    ref: this.contentRootRef,
  });

  isActionsDisabled = () => {
    return !!this.state.questionnaireUrl;
  };

  surveySlidesRenderer = () => {
    return <IframeComponent url={this.state.questionnaireUrl} />;
  };

  mainContentRenderer = (): React.ReactNode => {};

  dialogContentRenderer = () =>
    this.state.complete
      ? this.surveySlidesRenderer()
      : this.mainContentRenderer();
}

export default SurveyDialog;
